import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import Lib from '../../../commons/lib';
import SzemelyitorzsLista from './SzemelyitorzsLista';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from './SzemelyitorzsTooltips';

class SzemelyiTorzs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: (this.hasRole(['SZERVEZET_SZEMELYI'])) ? '1' : '2',
      type: 'SZERVEZET_SZEMELYI'
    };
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  hasRole = (roles) => {
    return this.props.globals.hasRole(roles);
  }

  render() {
    let cardStyle = {
      padding: 10
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {this.props.globals.hasRole(['SZERVEZET_SZEMELYI']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => { this.toggle('1'); }}
                      >
                        Személyi törzs
                        <CustomTooltip text={getTooltip('szemelyitorzs')} id="szemelyitorzsTT" />
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {this.props.globals.hasRole(['SZERVEZET_SZEMELYI']) && (
                    <TabPane tabId="1">
                      <SzemelyitorzsLista {...this.props} globals={this.props.globals} type={this.state.type} />
                    </TabPane>
                  )}
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SzemelyiTorzs.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default SzemelyiTorzs;